/** Safe-area insets in CSS pixels, one per viewport edge. */
export interface SafeAreaInsets {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

/**
 * Reads the `env(safe-area-inset-*)` values the WebView reports for the viewport: the space taken by
 * the status bar, the display cutout, the navigation bar or the home indicator on each edge.
 *
 * @returns The insets in CSS pixels; each is 0 when the platform reports none.
 */
export function readSafeAreaInsets(): SafeAreaInsets {
  const probe = document.createElement('div');
  probe.style.cssText =
    'position:fixed;visibility:hidden;padding:env(safe-area-inset-top,0px) env(safe-area-inset-right,0px) env(safe-area-inset-bottom,0px) env(safe-area-inset-left,0px)';
  document.body.appendChild(probe);
  const style = getComputedStyle(probe);
  const insets = {
    top: parseFloat(style.paddingTop) || 0,
    right: parseFloat(style.paddingRight) || 0,
    bottom: parseFloat(style.paddingBottom) || 0,
    left: parseFloat(style.paddingLeft) || 0,
  };
  probe.remove();
  return insets;
}
